import { Component, OnInit } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { catchError, of } from 'rxjs';
import { SelfServeLocalStorageUtil } from 'src/app/utils/local-storage.util';
import { UserService } from 'src/app/services/general/user.service';

@Component({
  selector: 'app-ios-account',
  templateUrl: './ios-account.component.html',
  styleUrls: ['./ios-account.component.scss'],
  standalone: false,
})
export class IosAccountComponent implements OnInit {
  firstName: string = '';
  lastName: string = '';
  email: string = '';

  readonly webAppUrl: string = window.location.origin;
  readonly appVersion: string = '1.0.0';
  readonly knowledgeBaseUrl = 'https://help.quantified.ai';
  readonly privacyPolicyUrl = 'https://www.quantified.ai/quantified-communications-inc-privacy-policy/';
  readonly termsUrl = 'https://www.quantified.ai/terms';
  private readonly helpEmail = 'mailto:help@quantified.ai';

  get initials(): string {
    const f = this.firstName.charAt(0).toUpperCase();
    const l = this.lastName.charAt(0).toUpperCase();
    return f + l || '?';
  }

  get fullName(): string {
    return `${this.firstName} ${this.lastName}`.trim();
  }

  constructor(private userService: UserService) {}

  async ngOnInit(): Promise<void> {
    const user = SelfServeLocalStorageUtil.getCurrentUser();
    this.firstName = user.firstName ?? '';
    this.lastName = user.lastName ?? '';

    const metadata: any = await firstValueFrom(
      this.userService.getAuthMetadata().pipe(catchError(() => of(null)))
    );
    this.email = metadata?.email || '';
  }

  openExternal(url: string): void {
    if (!this.isValidUrl(url)) {
      console.error('Invalid URL protocol. Only http: and https: are allowed:', url);
      return;
    }
    window.open(url, '_blank');
  }

  private isValidUrl(url: string): boolean {
    try {
      const parsedUrl = new URL(url);
      return parsedUrl.protocol === 'https:' ||
        (parsedUrl.protocol === 'http:' && parsedUrl.hostname === 'localhost');
    } catch {
      return false;
    }
  }

  openMailto(): void {
    window.open(this.helpEmail);
  }

  logout(): void {
    this.userService.logoutRequest().subscribe();
  }
}
